import Accordion from "@/components/Accordion";
import { LanguageConfigModel, StyleConfigModel } from "@/pages/Messaging/types";
import { Toggle } from "@velaro/velaro-component-lib";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";
import LogoUpload from "../../LogoUpload";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
  setStagedContentWidgetImageFile: (file: File | null) => void;
}

export function Content(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};
  const workingStyleConfig = props.workingChatWindow.styleConfig || {};

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };

  const updateStyleConfig = (updates: Partial<StyleConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      styleConfig: {
        ...workingStyleConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item eventKey="content" onExpanded={() => props.onExpanded()}>
      <Accordion.Header>
        <Accordion.Title>Content Widget</Accordion.Title>
        <Accordion.SubTitle>
          Promote interactive content to users via landing page
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-2">
          <LogoUpload
            setStageLogoFile={props.setStagedContentWidgetImageFile}
            update={updateStyleConfig}
            workingStyleConfig={workingStyleConfig}
            field="contentWidgetImageUrl"
            label="Image"
            accept="image/png,image/jpeg,image/webp"
            maxSizeMb={2}
            maxWidth={1200}
            maxHeight={600}
            sizeGuidance="PNG, JPG, or WebP • Wide/landscape image works best • Larger images auto-resized"
            previewClassName="w-full h-full object-cover"
          />
          <div className="my-3 border-t border-slate-200" />
          <div className="flex justify-between items-center">
            <div className="text-sm font-medium">Enable</div>
            <Toggle
              toggled={workingLanguageConfig.contentWidgetEnabled ?? false}
              changeToggle={() =>
                updateLanguageConfig({
                  contentWidgetEnabled: !workingLanguageConfig.contentWidgetEnabled
                })
              }
            />
          </div>
          <div className="my-3 border-t border-slate-200" />
          <div className="text-sm font-medium mb-2">Title</div>
          <TextInput
            value={workingLanguageConfig.contentWidgetTitle ?? ""}
            setValue={(value) =>
              updateLanguageConfig({ contentWidgetTitle: value })
            }
            showEmojiButton={false}
          />
          <div className="text-sm font-medium my-2">Body</div>
          <TextInput
            value={workingLanguageConfig.contentWidgetBody ?? ""}
            setValue={(value) =>
              updateLanguageConfig({ contentWidgetBody: value })
            }
            showEmojiButton={false}
          />
          <div className="text-sm font-medium my-2">Button Text</div>
          <TextInput
            value={workingLanguageConfig.contentWidgetButtonText ?? ""}
            setValue={(value) =>
              updateLanguageConfig({ contentWidgetButtonText: value })
            }
            showEmojiButton={false}
          />
          <div className="text-sm font-medium my-2">Button URL</div>
          <TextInput
            value={workingLanguageConfig.contentWidgetButtonUrl ?? ""}
            setValue={(value) =>
              updateLanguageConfig({ contentWidgetButtonUrl: value })
            }
            showEmojiButton={false}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
